/* global attachEvent */

// *******************************************************************************
// 1.0 - Close Video Modal
// *******************************************************************************

const closeVideo = (ev) => {
  const parent = ev.target.closest('.video-modal');
  const modalVideoIframe = parent.querySelector('.video__iframe-container');
  const modalVideoIframeParent = parent.querySelector('.video__iframe');
  parent.classList.remove('is-open-video-modal');

  if (typeof modalVideoIframe !== 'undefined' && modalVideoIframe != null) {
    modalVideoIframe.remove();
    modalVideoIframeParent.innerHTML = "<div class='video__iframe-container'></div>";
  }
};

attachEvent('.video-modal__close', 'click', (ev) => {
  closeVideo(ev);
});

// Close tv fullscreen
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.video-modal.is-open-video-modal').forEach((el) => {
      closeVideo(el);
    });
  }
});
